import { AUTHORIZE } from "./types";
import { getAuthorizationToken } from "../../connections/atlassian/http.header.authorization";
import { isJira, isConfluence } from "../../connections/atlassian/ap";

export const isAtlassian = () => {
  if (isJira() || isConfluence()) {
    return true;
  }
  return false;
};
const defaultEnvironment = () => {
  if (process.env.NODE_ENV === "development") {
    return true;
  }
  return false;
};

export const checkForTokens = () => (dispatch: any) => {
  if (isAtlassian()) {
    getAuthorizationToken()
      .then(() => {
        dispatch({
          type: AUTHORIZE,
          payload: true,
        });
      })
      .catch(() => {
        dispatch({
          type: AUTHORIZE,
          payload: false,
        });
      });
  } else {
    dispatch({
      type: AUTHORIZE,
      payload: defaultEnvironment(),
    });
  }
};
